import { render, staticRenderFns } from "./NameInfo.vue?vue&type=template&id=1959d571&"
import script from "./NameInfo.vue?vue&type=script&lang=js&"
export * from "./NameInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports